import { createSelector } from 'redux-bundler';

export const selectAllOrganizationIDs = ({ organizations }) =>
  organizations?.base?.allIDs || [];
export const selectOrganizationsById = ({ organizations }) =>
  organizations?.base?.byId || {};

export const selectCurrentOrganizationId = createSelector(
  'selectRouteParams',
  ({ organizationId }) => organizationId || null,
);

export const selectDefaultOrganizationId = createSelector(
  'selectAllOrganizationIDs',
  (allIDs) => allIDs[0],
);

export const selectDefaultOrganization = createSelector(
  'selectDefaultOrganizationId',
  'selectOrganizationsById',
  (id, byId) => byId?.[id] || {},
);

export const selectCurrentOrganization = createSelector(
  'selectOrganizationsById',
  'selectCurrentOrganizationId',
  (organizationsById, currentOrganizationId) =>
    organizationsById?.[currentOrganizationId] || {},
);
